import React from 'react';
import { useNavigate } from 'react-router-dom';
import Layout from '../components/Layout';
import { Button } from '../components/ui/button';
import { useAuth } from '../contexts/AuthContext';
import { Crown, Handshake, Sparkles, Target } from 'lucide-react';

const PracticeWithFriend = () => {
  const navigate = useNavigate();
  const { user } = useAuth();
  const isPremium = user?.premium;

  if (!isPremium) {
    return (
      <Layout>
        <div className="max-w-2xl mx-auto px-4 py-16 text-center">
          <Crown className="text-yellow-500 mx-auto mb-4" size={64} />
          <h1 className="text-3xl font-bold text-foreground dark:text-white mb-4">Practice with Friend</h1>
          <p className="text-muted-foreground mb-8">
            This feature is exclusively for premium members. Practice questions with friends and learn together in real-time.
          </p>
          <Button
            onClick={() => navigate('/subscription')}
            className="bg-gradient-to-r from-yellow-500 to-amber-500 hover:from-yellow-600 hover:to-amber-600 text-white"
          >
            <Crown size={20} className="mr-2" />
            Upgrade to Premium
          </Button>
        </div>
      </Layout>
    );
  }

  return (
    <Layout>
      <div className="max-w-md mx-auto px-4 py-16 text-center">
        {/* Icon */}
        <div className="w-20 h-20 bg-gradient-to-br from-emerald-500 to-teal-500 rounded-2xl flex items-center justify-center mx-auto mb-6">
          <Handshake className="text-white" size={40} />
        </div>

        {/* Title */}
        <h1 className="text-2xl font-bold text-foreground dark:text-white mb-2">Practice with Friend</h1>

        {/* Coming Soon Badge */}
        <div className="inline-flex items-center gap-2 px-4 py-2 bg-emerald-500/10 rounded-full border border-emerald-500/30 mb-8">
          <Sparkles className="text-emerald-500" size={18} />
          <span className="font-medium text-emerald-600 dark:text-emerald-400">Coming Soon</span>
        </div>

        {/* Solo Practice Button */}
        <Button onClick={() => navigate('/practice')} variant="outline" className="w-full max-w-xs">
          <Target size={16} className="mr-2" /> Solo Practice
        </Button>
      </div>
    </Layout>
  );
};

export default PracticeWithFriend;
